function createFormData(values) {
  const formData = new FormData();
  for (let key of Object.keys(values)) {
    formData.append(key, values[key]);
  }
  return formData;
}

export default createFormData;
